<!-- En-tête collant d'une messagerie (maquette 12) : le chevron referme la
     feuille, le menu garde les trois gestes rares hors de la vue. -->
<header class="flex shrink-0 items-center gap-2 border-b border-vw-line px-2 pb-2 pt-6">
  <button type="button"
    class="flex h-target w-target shrink-0 items-center justify-center rounded-pill text-vw-body active:bg-vw-surface-sunk"
    [attr.aria-label]="'willy.close' | translate" (click)="onCloseClick()">
    <vw-down-icon />
  </button>
  <img src="/assets/images/willy/willy_hi.webp" alt="" class="h-8 w-8 shrink-0 rounded-pill bg-vw-surface-tint object-contain">
  <div class="min-w-0 grow">
    <p class="text-body font-semibold text-vw-ink">Willy</p>
    <p class="truncate text-body-s text-vw-muted">
      {{ (isReported ? 'common.modals.ai-actions.content.message.reported' : 'willy.tagline') | translate }}
    </p>
  </div>
  @if (showMenu) {
    <div class="relative shrink-0">
      <button type="button"
        class="flex h-target w-target items-center justify-center rounded-pill text-vw-body active:bg-vw-surface-sunk"
        aria-haspopup="menu" [attr.aria-expanded]="menuOpen" [attr.aria-label]="'willy.menu.label' | translate"
        (click)="menuOpen = !menuOpen">
        <vw-three-dots-icon class="rotate-90" />
      </button>
      @if (menuOpen) {
        <!-- Toucher à côté referme le menu, sans rien déclencher dessous. -->
        <div class="fixed inset-0 z-40" aria-hidden="true" (click)="menuOpen = false"></div>
        <div role="menu"
          class="absolute right-0 top-full z-50 mt-1 flex w-64 flex-col overflow-hidden rounded-card border border-vw-line bg-vw-surface shadow-float">
          <button type="button" role="menuitem"
            class="flex min-h-target items-center gap-3 px-4 text-left text-body font-semibold text-vw-ink active:bg-vw-surface-sunk"
            (click)="onNewConversationClick()">
            <vw-square-pen-icon class="flex h-5 w-5 shrink-0" />{{ 'willy.new-conversation' | translate }}
          </button>
          <button type="button" role="menuitem"
            class="flex min-h-target items-center gap-3 border-t border-vw-line px-4 text-left text-body font-semibold text-vw-ink active:bg-vw-surface-sunk"
            (click)="onInfoClick()">
            <vw-info-icon class="flex h-5 w-5 shrink-0" />{{ 'willy.menu.info' | translate }}
          </button>
          <button type="button" role="menuitem"
            class="flex min-h-target items-center gap-3 border-t border-vw-line px-4 text-left text-body font-semibold text-vw-ink active:bg-vw-surface-sunk"
            (click)="onFlagClick()">
            <vw-flag-icon class="flex h-5 w-5 shrink-0" />{{ 'willy.menu.report' | translate }}
          </button>
        </div>
      }
    </div>
  }
</header>
<vw-report-modal [isOpen]="showReportPopup" [answer]="lastAnswer" (onReport)="onReport()"
  (onModalClosed)="showReportPopup = false"></vw-report-modal>
<vw-ai-chatbot-info-modal [isOpen]="showInfoPopup" (onModalClosed)="onInfoModalClose()"></vw-ai-chatbot-info-modal>
